export const PLATFORM_USER_ACCESS_ACTIONS = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  USERS: "USERS",
  CUSTOMERS: "CUSTOMERS",
  CUSTOMER_ROLES: "CUSTOMER_ROLES",
  LIST_FILTERS: "LIST_FILTERS",
  INVITE_MODAL: "INVITE_MODAL",
  SELECTED_USER_ID: "SELECTED_USER_ID",
  SELECTED_USER_DETAILS: "SELECTED_USER_DETAILS",
};

export const PlatformUserAccessReducer = (state, action) => {
  switch (action.type) {
    case PLATFORM_USER_ACCESS_ACTIONS.LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case PLATFORM_USER_ACCESS_ACTIONS.ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case PLATFORM_USER_ACCESS_ACTIONS.USERS:
      return {
        ...state,
        users: action.payload.list ?? [],
        pagination: action.payload.pagination ?? state.pagination,
      };
    case PLATFORM_USER_ACCESS_ACTIONS.CUSTOMERS:
      return {
        ...state,
        customers: action.payload ?? [],
      };
    case PLATFORM_USER_ACCESS_ACTIONS.CUSTOMER_ROLES:
      return {
        ...state,
        customerRoleOptions: action.payload ?? [],
      };
    case PLATFORM_USER_ACCESS_ACTIONS.LIST_FILTERS:
      return {
        ...state,
        listFilters: action.payload ?? state.listFilters,
      };
    case PLATFORM_USER_ACCESS_ACTIONS.INVITE_MODAL:
      return {
        ...state,
        isInviteModalOpen: action.payload,
      };
    case PLATFORM_USER_ACCESS_ACTIONS.SELECTED_USER_ID:
      return {
        ...state,
        selectedUserId: action.payload,
      };
    case PLATFORM_USER_ACCESS_ACTIONS.SELECTED_USER_DETAILS:
      return {
        ...state,
        selectedUserDetails: action.payload,
      };
    default:
      return state;
  }
};
